module.exports = __webpack_public_path__ + "static/media/network.67953f7d.svg";